/** Where a clip opens in AutoCut Studio (`/clips/:id/freecut` redirects here). */
export const clipStudioPath = (clipId: string): string => `/clips/${clipId}/autocut`;
